// <auto-generated>
// This file is automatically generated by the Nexo CLI.
// Do not modify this file directly. Changes will be overwritten.
// Source: CLI error-codes-frontend generator
// Generated: 2026-04-29T13:20:44.641Z
// </auto-generated>

/** All error codes organized by Module > Entity > Code */
export const ErrorCodes = {
  Finance: {
    Account: {
      NotFound: 'Nexo:Finance:Account:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:Account:ConcurrencyConflict',
      DuplicateAccountNumber: 'Nexo:Finance:Account:DuplicateAccountNumber',
    },
    AccountDerivationRule: {
      NotFound: 'Nexo:Finance:AccountDerivationRule:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:AccountDerivationRule:ConcurrencyConflict',
    },
    AccountDimensionRule: {
      NotFound: 'Nexo:Finance:AccountDimensionRule:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:AccountDimensionRule:ConcurrencyConflict',
    },
    AccountGroup: {
      NotFound: 'Nexo:Finance:AccountGroup:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:AccountGroup:ConcurrencyConflict',
    },
    DimensionDefinition: {
      NotFound: 'Nexo:Finance:DimensionDefinition:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:DimensionDefinition:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Finance:DimensionDefinition:DuplicateCode',
      DuplicateName: 'Nexo:Finance:DimensionDefinition:DuplicateName',
    },
    DimensionDefinitionModule: {
      NotFound: 'Nexo:Finance:DimensionDefinitionModule:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:DimensionDefinitionModule:ConcurrencyConflict',
    },
    DimensionSet: {
      NotFound: 'Nexo:Finance:DimensionSet:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:DimensionSet:ConcurrencyConflict',
      DuplicateHash: 'Nexo:Finance:DimensionSet:DuplicateHash',
    },
    DimensionValue: {
      NotFound: 'Nexo:Finance:DimensionValue:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:DimensionValue:ConcurrencyConflict',
      InUseCannotDelete: 'Nexo:Finance:DimensionValue:InUseCannotDelete',
    },
    DistributionProfile: {
      NotFound: 'Nexo:Finance:DistributionProfile:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:DistributionProfile:ConcurrencyConflict',
    },
    DistributionProfileLine: {
      NotFound: 'Nexo:Finance:DistributionProfileLine:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:DistributionProfileLine:ConcurrencyConflict',
    },
    FiscalPeriod: {
      InvalidStateTransition: 'Nexo:Finance:FiscalPeriod:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Finance:FiscalPeriod:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Finance:FiscalPeriod:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Finance:FiscalPeriod:RuleExecutionFailed',
      NotFound: 'Nexo:Finance:FiscalPeriod:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:FiscalPeriod:ConcurrencyConflict',
    },
    FiscalYear: {
      NotFound: 'Nexo:Finance:FiscalYear:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:FiscalYear:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Finance:FiscalYear:DuplicateCode',
    },
    Measure: {
      NotFound: 'Nexo:Finance:Measure:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:Measure:ConcurrencyConflict',
    },
    PlanAllocation: {
      NotFound: 'Nexo:Finance:PlanAllocation:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanAllocation:ConcurrencyConflict',
    },
    PlanHeader: {
      InvalidStateTransition: 'Nexo:Finance:PlanHeader:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Finance:PlanHeader:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Finance:PlanHeader:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Finance:PlanHeader:RuleExecutionFailed',
      NotFound: 'Nexo:Finance:PlanHeader:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanHeader:ConcurrencyConflict',
      ScopePinCollidesWithRowAxis: 'Nexo:Finance:PlanHeader:ScopePinCollidesWithRowAxis',
      SubmitBlockedByEmptyHeader: 'Nexo:Finance:PlanHeader:SubmitBlockedByEmptyHeader',
      SubmitRequiresRowAccess: 'Nexo:Finance:PlanHeader:SubmitRequiresRowAccess',
      ReturnRequiresApprovingCapacity: 'Nexo:Finance:PlanHeader:ReturnRequiresApprovingCapacity',
      ReevaluateRequiresEditableStatus: 'Nexo:Finance:PlanHeader:ReevaluateRequiresEditableStatus',
      ReevaluateRequiresEditableVersion: 'Nexo:Finance:PlanHeader:ReevaluateRequiresEditableVersion',
      ReevaluateAlreadyRunning: 'Nexo:Finance:PlanHeader:ReevaluateAlreadyRunning',
      ReevaluateNothingEligible: 'Nexo:Finance:PlanHeader:ReevaluateNothingEligible',
      EntryBlockedWhileReevaluating: 'Nexo:Finance:PlanHeader:EntryBlockedWhileReevaluating',
      ReevaluateSelectionContested: 'Nexo:Finance:PlanHeader:ReevaluateSelectionContested',
    },
    PlanHeaderScope: {
      NotFound: 'Nexo:Finance:PlanHeaderScope:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanHeaderScope:ConcurrencyConflict',
    },
    PlanLine: {
      NotFound: 'Nexo:Finance:PlanLine:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanLine:ConcurrencyConflict',
    },
    PlanLineReevaluationRun: {
      NotFound: 'Nexo:Finance:PlanLineReevaluationRun:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanLineReevaluationRun:ConcurrencyConflict',
      SystemProduced: 'Nexo:Finance:PlanLineReevaluationRun:SystemProduced',
      DuplicateRunNumber: 'Nexo:Finance:PlanLineReevaluationRun:DuplicateRunNumber',
    },
    PlanScenario: {
      NotFound: 'Nexo:Finance:PlanScenario:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanScenario:ConcurrencyConflict',
      ScenarioCodeConflict: 'Nexo:Finance:PlanScenario:ScenarioCodeConflict',
      SourceScenarioHasNoVersions: 'Nexo:Finance:PlanScenario:SourceScenarioHasNoVersions',
      SourceVersionNotInScenario: 'Nexo:Finance:PlanScenario:SourceVersionNotInScenario',
      InvalidScenarioType: 'Nexo:Finance:PlanScenario:InvalidScenarioType',
      TargetFiscalYearNotFound: 'Nexo:Finance:PlanScenario:TargetFiscalYearNotFound',
    },
    PlanStatementRow: {
      NotFound: 'Nexo:Finance:PlanStatementRow:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanStatementRow:ConcurrencyConflict',
    },
    PlanStatementTemplate: {
      NotFound: 'Nexo:Finance:PlanStatementTemplate:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanStatementTemplate:ConcurrencyConflict',
      DuplicateRowCode: 'Nexo:Finance:PlanStatementTemplate:DuplicateRowCode',
      FormulaUnknownReference: 'Nexo:Finance:PlanStatementTemplate:FormulaUnknownReference',
      PercentOfUnknownReference: 'Nexo:Finance:PlanStatementTemplate:PercentOfUnknownReference',
      FormulaCycle: 'Nexo:Finance:PlanStatementTemplate:FormulaCycle',
    },
    PlanVersion: {
      InvalidStateTransition: 'Nexo:Finance:PlanVersion:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Finance:PlanVersion:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Finance:PlanVersion:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Finance:PlanVersion:RuleExecutionFailed',
      NotFound: 'Nexo:Finance:PlanVersion:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanVersion:ConcurrencyConflict',
      BudgetPublishRequiresApprovedState: 'Nexo:Finance:PlanVersion:BudgetPublishRequiresApprovedState',
      WhatIfCannotBePublished: 'Nexo:Finance:PlanVersion:WhatIfCannotBePublished',
      PublishBlockedByLockedVersion: 'Nexo:Finance:PlanVersion:PublishBlockedByLockedVersion',
      VersionNumberConflict: 'Nexo:Finance:PlanVersion:VersionNumberConflict',
      PublishRequiresLines: 'Nexo:Finance:PlanVersion:PublishRequiresLines',
      PublishBlockedByPendingLines: 'Nexo:Finance:PlanVersion:PublishBlockedByPendingLines',
      PublishAlreadyInProgress: 'Nexo:Finance:PlanVersion:PublishAlreadyInProgress',
      PublishBlockedByReevaluation: 'Nexo:Finance:PlanVersion:PublishBlockedByReevaluation',
      PublishBlockedByMissingReference: 'Nexo:Finance:PlanVersion:PublishBlockedByMissingReference',
      SubmitBlockedByUnsubmittedHeaders: 'Nexo:Finance:PlanVersion:SubmitBlockedByUnsubmittedHeaders',
      ApprovalPending: 'Nexo:Finance:PlanVersion:ApprovalPending',
      SubmitRequiresBudgetScenario: 'Nexo:Finance:PlanVersion:SubmitRequiresBudgetScenario',
    },
    PlanVersionPublishRun: {
      NotFound: 'Nexo:Finance:PlanVersionPublishRun:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanVersionPublishRun:ConcurrencyConflict',
    },
    PlanView: {
      NotFound: 'Nexo:Finance:PlanView:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanView:ConcurrencyConflict',
      MeasureFormulaRequiresDerivedKind: 'Nexo:Finance:PlanView:MeasureFormulaRequiresDerivedKind',
      DerivedAmountRequiresFormula: 'Nexo:Finance:PlanView:DerivedAmountRequiresFormula',
      MeasureWeightInvalid: 'Nexo:Finance:PlanView:MeasureWeightInvalid',
      MeasuresFrozenByPublishedVersion: 'Nexo:Finance:PlanView:MeasuresFrozenByPublishedVersion',
      MeasuresFrozenBySubmittedHeader: 'Nexo:Finance:PlanView:MeasuresFrozenBySubmittedHeader',
      MeasureChangedAfterFiguresEntered: 'Nexo:Finance:PlanView:MeasureChangedAfterFiguresEntered',
      MeasureFormulaCycle: 'Nexo:Finance:PlanView:MeasureFormulaCycle',
      StorageBindingNotValidForKind: 'Nexo:Finance:PlanView:StorageBindingNotValidForKind',
      MeasureFormulaInvalid: 'Nexo:Finance:PlanView:MeasureFormulaInvalid',
      MeasureResultOutOfRange: 'Nexo:Finance:PlanView:MeasureResultOutOfRange',
      DuplicateRowAxis: 'Nexo:Finance:PlanView:DuplicateRowAxis',
      DuplicateMeasureCode: 'Nexo:Finance:PlanView:DuplicateMeasureCode',
      DuplicateFixedStorageBinding: 'Nexo:Finance:PlanView:DuplicateFixedStorageBinding',
    },
    PlanViewRowDimension: {
      NotFound: 'Nexo:Finance:PlanViewRowDimension:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanViewRowDimension:ConcurrencyConflict',
    },
    VatCode: {
      NotFound: 'Nexo:Finance:VatCode:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:VatCode:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Finance:VatCode:DuplicateCode',
    },
  },
  Forestry: {
    Agreement: {
      InvalidStateTransition: 'Nexo:Forestry:Agreement:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Forestry:Agreement:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Forestry:Agreement:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Forestry:Agreement:RuleExecutionFailed',
      NotFound: 'Nexo:Forestry:Agreement:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:Agreement:ConcurrencyConflict',
      DuplicateAgreementNumber: 'Nexo:Forestry:Agreement:DuplicateAgreementNumber',
    },
    CalculationComponent: {
      NotFound: 'Nexo:Forestry:CalculationComponent:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:CalculationComponent:ConcurrencyConflict',
      ValueSideHasNoCostType: 'Nexo:Forestry:CalculationComponent:ValueSideHasNoCostType',
      PerQuantityRequiresUnit: 'Nexo:Forestry:CalculationComponent:PerQuantityRequiresUnit',
      PercentRequiresOtherBasis: 'Nexo:Forestry:CalculationComponent:PercentRequiresOtherBasis',
      ValueSideFromPriceList: 'Nexo:Forestry:CalculationComponent:ValueSideFromPriceList',
      ChargeOnlyOnCost: 'Nexo:Forestry:CalculationComponent:ChargeOnlyOnCost',
      ChangedInActivatedTemplate: 'Nexo:Forestry:CalculationComponent:ChangedInActivatedTemplate',
      DuplicateCode: 'Nexo:Forestry:CalculationComponent:DuplicateCode',
    },
    CalculationComponentAllocationProductGroup: {
      NotFound: 'Nexo:Forestry:CalculationComponentAllocationProductGroup:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:CalculationComponentAllocationProductGroup:ConcurrencyConflict',
    },
    CalculationTemplate: {
      NotFound: 'Nexo:Forestry:CalculationTemplate:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:CalculationTemplate:ConcurrencyConflict',
      DuplicateTradeTypeId: 'Nexo:Forestry:CalculationTemplate:DuplicateTradeTypeId',
    },
    CalculationTemplateLine: {
      NotFound: 'Nexo:Forestry:CalculationTemplateLine:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:CalculationTemplateLine:ConcurrencyConflict',
      TemplateLineIsImmutable: 'Nexo:Forestry:CalculationTemplateLine:TemplateLineIsImmutable',
      FormulaOnlyForFormulaComponent: 'Nexo:Forestry:CalculationTemplateLine:FormulaOnlyForFormulaComponent',
      DefaultValueOnlyForManualComponent: 'Nexo:Forestry:CalculationTemplateLine:DefaultValueOnlyForManualComponent',
      QuantitySourceMismatch: 'Nexo:Forestry:CalculationTemplateLine:QuantitySourceMismatch',
      ValueSideLineHasNoScope: 'Nexo:Forestry:CalculationTemplateLine:ValueSideLineHasNoScope',
      DefaultChargeMismatch: 'Nexo:Forestry:CalculationTemplateLine:DefaultChargeMismatch',
    },
    CalculationTemplateLineProductGroup: {
      NotFound: 'Nexo:Forestry:CalculationTemplateLineProductGroup:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:CalculationTemplateLineProductGroup:ConcurrencyConflict',
    },
    CalculationTemplateVersion: {
      InvalidStateTransition: 'Nexo:Forestry:CalculationTemplateVersion:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Forestry:CalculationTemplateVersion:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Forestry:CalculationTemplateVersion:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Forestry:CalculationTemplateVersion:RuleExecutionFailed',
      NotFound: 'Nexo:Forestry:CalculationTemplateVersion:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:CalculationTemplateVersion:ConcurrencyConflict',
      TemplateVersionIsImmutable: 'Nexo:Forestry:CalculationTemplateVersion:TemplateVersionIsImmutable',
      TemplateVersionHasInvalidLines: 'Nexo:Forestry:CalculationTemplateVersion:TemplateVersionHasInvalidLines',
      TemplateVersionValidFromInvalid: 'Nexo:Forestry:CalculationTemplateVersion:TemplateVersionValidFromInvalid',
    },
    Contract: {
      NotFound: 'Nexo:Forestry:Contract:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:Contract:ConcurrencyConflict',
      PriceAreasKeptOnceAgreementActive: 'Nexo:Forestry:Contract:PriceAreasKeptOnceAgreementActive',
      DuplicateContractNumber: 'Nexo:Forestry:Contract:DuplicateContractNumber',
    },
    ContractArea: {
      NotFound: 'Nexo:Forestry:ContractArea:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:ContractArea:ConcurrencyConflict',
      TreeSpeciesSharesMustAddUpTo100: 'Nexo:Forestry:ContractArea:TreeSpeciesSharesMustAddUpTo100',
    },
    ContractAreaTreeSpecies: {
      NotFound: 'Nexo:Forestry:ContractAreaTreeSpecies:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:ContractAreaTreeSpecies:ConcurrencyConflict',
    },
    ContractCertificate: {
      NotFound: 'Nexo:Forestry:ContractCertificate:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:ContractCertificate:ConcurrencyConflict',
    },
    ContractLineItem: {
      NotFound: 'Nexo:Forestry:ContractLineItem:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:ContractLineItem:ConcurrencyConflict',
    },
    CostType: {
      NotFound: 'Nexo:Forestry:CostType:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:CostType:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Forestry:CostType:DuplicateCode',
    },
    LoadObservation: {
      NotFound: 'Nexo:Forestry:LoadObservation:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:LoadObservation:ConcurrencyConflict',
    },
    LoadObservationItem: {
      NotFound: 'Nexo:Forestry:LoadObservationItem:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:LoadObservationItem:ConcurrencyConflict',
    },
    Organization: {
      NotFound: 'Nexo:Forestry:Organization:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:Organization:ConcurrencyConflict',
      DuplicateOrganizationCode: 'Nexo:Forestry:Organization:DuplicateOrganizationCode',
    },
    PreCalculation: {
      NotFound: 'Nexo:Forestry:PreCalculation:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:PreCalculation:ConcurrencyConflict',
      ContractNotCalculable: 'Nexo:Forestry:PreCalculation:ContractNotCalculable',
      NoActiveTemplateVersion: 'Nexo:Forestry:PreCalculation:NoActiveTemplateVersion',
      DuplicatePreCalculationNumber: 'Nexo:Forestry:PreCalculation:DuplicatePreCalculationNumber',
    },
    PreCalculationCostPost: {
      NotFound: 'Nexo:Forestry:PreCalculationCostPost:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:PreCalculationCostPost:ConcurrencyConflict',
      CostPostTotalNeedsTerm: 'Nexo:Forestry:PreCalculationCostPost:CostPostTotalNeedsTerm',
      CostPostPriceOnlyWhenFixed: 'Nexo:Forestry:PreCalculationCostPost:CostPostPriceOnlyWhenFixed',
      CostPostFixedTotalNeedsPrice: 'Nexo:Forestry:PreCalculationCostPost:CostPostFixedTotalNeedsPrice',
      CostPostAreaTakesTotalTerm: 'Nexo:Forestry:PreCalculationCostPost:CostPostAreaTakesTotalTerm',
    },
    PreCalculationDriver: {
      NotFound: 'Nexo:Forestry:PreCalculationDriver:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:PreCalculationDriver:ConcurrencyConflict',
    },
    PreCalculationLine: {
      NotFound: 'Nexo:Forestry:PreCalculationLine:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:PreCalculationLine:ConcurrencyConflict',
    },
    PriceAreaAssortment: {
      NotFound: 'Nexo:Forestry:PriceAreaAssortment:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:PriceAreaAssortment:ConcurrencyConflict',
    },
    PriceDimension: {
      NotFound: 'Nexo:Forestry:PriceDimension:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:PriceDimension:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Forestry:PriceDimension:DuplicateCode',
      DuplicateSortOrder: 'Nexo:Forestry:PriceDimension:DuplicateSortOrder',
    },
    PriceDimensionClass: {
      NotFound: 'Nexo:Forestry:PriceDimensionClass:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:PriceDimensionClass:ConcurrencyConflict',
      InvalidClassBounds: 'Nexo:Forestry:PriceDimensionClass:InvalidClassBounds',
    },
    PriceDimensionClassCombination: {
      NotFound: 'Nexo:Forestry:PriceDimensionClassCombination:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:PriceDimensionClassCombination:ConcurrencyConflict',
      CombinationIsImmutable: 'Nexo:Forestry:PriceDimensionClassCombination:CombinationIsImmutable',
      MoreThanOneClassPerDimension: 'Nexo:Forestry:PriceDimensionClassCombination:MoreThanOneClassPerDimension',
      DuplicateHash: 'Nexo:Forestry:PriceDimensionClassCombination:DuplicateHash',
    },
    PriceDimensionClassSet: {
      NotFound: 'Nexo:Forestry:PriceDimensionClassSet:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:PriceDimensionClassSet:ConcurrencyConflict',
      IntervalClassesNotContiguous: 'Nexo:Forestry:PriceDimensionClassSet:IntervalClassesNotContiguous',
    },
    SigningRow: {
      InvalidStateTransition: 'Nexo:Forestry:SigningRow:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Forestry:SigningRow:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Forestry:SigningRow:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Forestry:SigningRow:RuleExecutionFailed',
      NotFound: 'Nexo:Forestry:SigningRow:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:SigningRow:ConcurrencyConflict',
    },
    SupplyPoint: {
      NotFound: 'Nexo:Forestry:SupplyPoint:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:SupplyPoint:ConcurrencyConflict',
      RouteDistanceRequiresCoordinates: 'Nexo:Forestry:SupplyPoint:RouteDistanceRequiresCoordinates',
      RouteDistanceFailed: 'Nexo:Forestry:SupplyPoint:RouteDistanceFailed',
      DuplicateSupplyPointId: 'Nexo:Forestry:SupplyPoint:DuplicateSupplyPointId',
    },
    VolumeBasisLine: {
      NotFound: 'Nexo:Forestry:VolumeBasisLine:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:VolumeBasisLine:ConcurrencyConflict',
      VolumeMustBeNonNegativeM3f: 'Nexo:Forestry:VolumeBasisLine:VolumeMustBeNonNegativeM3f',
      ClassNotMeasuredOnBasisLine: 'Nexo:Forestry:VolumeBasisLine:ClassNotMeasuredOnBasisLine',
    },
    Workorder: {
      NotFound: 'Nexo:Forestry:Workorder:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:Workorder:ConcurrencyConflict',
      DuplicateWorkorderNumber: 'Nexo:Forestry:Workorder:DuplicateWorkorderNumber',
      DuplicateDeliverySourceId: 'Nexo:Forestry:Workorder:DuplicateDeliverySourceId',
    },
    WorkorderItem: {
      NotFound: 'Nexo:Forestry:WorkorderItem:NotFound',
      ConcurrencyConflict: 'Nexo:Forestry:WorkorderItem:ConcurrencyConflict',
    },
  },
  Workflow: {
    ApprovalDelegation: {
      NotFound: 'Nexo:Workflow:ApprovalDelegation:NotFound',
      ConcurrencyConflict: 'Nexo:Workflow:ApprovalDelegation:ConcurrencyConflict',
    },
    ApprovalPolicy: {
      NotFound: 'Nexo:Workflow:ApprovalPolicy:NotFound',
      ConcurrencyConflict: 'Nexo:Workflow:ApprovalPolicy:ConcurrencyConflict',
      PolicyHasNoSteps: 'Nexo:Workflow:ApprovalPolicy:PolicyHasNoSteps',
      NoApproversResolved: 'Nexo:Workflow:ApprovalPolicy:NoApproversResolved',
      DuplicateOpenRequest: 'Nexo:Workflow:ApprovalPolicy:DuplicateOpenRequest',
      StepMissingApprover: 'Nexo:Workflow:ApprovalPolicy:StepMissingApprover',
      StepMissingPermission: 'Nexo:Workflow:ApprovalPolicy:StepMissingPermission',
      StepMissingQuorumCount: 'Nexo:Workflow:ApprovalPolicy:StepMissingQuorumCount',
      UnsupportedAssignmentStrategy: 'Nexo:Workflow:ApprovalPolicy:UnsupportedAssignmentStrategy',
      PolicyEntityTypeMismatch: 'Nexo:Workflow:ApprovalPolicy:PolicyEntityTypeMismatch',
    },
    ApprovalPolicyStep: {
      NotFound: 'Nexo:Workflow:ApprovalPolicyStep:NotFound',
      ConcurrencyConflict: 'Nexo:Workflow:ApprovalPolicyStep:ConcurrencyConflict',
    },
    ApprovalRequest: {
      InvalidStateTransition: 'Nexo:Workflow:ApprovalRequest:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Workflow:ApprovalRequest:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Workflow:ApprovalRequest:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Workflow:ApprovalRequest:RuleExecutionFailed',
      NotFound: 'Nexo:Workflow:ApprovalRequest:NotFound',
      ConcurrencyConflict: 'Nexo:Workflow:ApprovalRequest:ConcurrencyConflict',
      DuplicateRequestNumber: 'Nexo:Workflow:ApprovalRequest:DuplicateRequestNumber',
    },
  },
  Core: {
    Area: {
      NotFound: 'Nexo:Core:Area:NotFound',
      ConcurrencyConflict: 'Nexo:Core:Area:ConcurrencyConflict',
      DistrictInAnotherActiveArea: 'Nexo:Core:Area:DistrictInAnotherActiveArea',
      ProductGroupNotAllowed: 'Nexo:Core:Area:ProductGroupNotAllowed',
    },
    AreaDistrict: {
      NotFound: 'Nexo:Core:AreaDistrict:NotFound',
      ConcurrencyConflict: 'Nexo:Core:AreaDistrict:ConcurrencyConflict',
      AreaDistrictIsImmutable: 'Nexo:Core:AreaDistrict:AreaDistrictIsImmutable',
    },
    AreaType: {
      NotFound: 'Nexo:Core:AreaType:NotFound',
      ConcurrencyConflict: 'Nexo:Core:AreaType:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:AreaType:DuplicateCode',
    },
    AreaVersion: {
      InvalidStateTransition: 'Nexo:Core:AreaVersion:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Core:AreaVersion:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Core:AreaVersion:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Core:AreaVersion:RuleExecutionFailed',
      NotFound: 'Nexo:Core:AreaVersion:NotFound',
      ConcurrencyConflict: 'Nexo:Core:AreaVersion:ConcurrencyConflict',
      AreaVersionIsImmutable: 'Nexo:Core:AreaVersion:AreaVersionIsImmutable',
      AreaVersionValidFromInvalid: 'Nexo:Core:AreaVersion:AreaVersionValidFromInvalid',
    },
    AssignmentPolicy: {
      NotFound: 'Nexo:Core:AssignmentPolicy:NotFound',
      ConcurrencyConflict: 'Nexo:Core:AssignmentPolicy:ConcurrencyConflict',
    },
    BatchJob: {
      NotFound: 'Nexo:Core:BatchJob:NotFound',
      ConcurrencyConflict: 'Nexo:Core:BatchJob:ConcurrencyConflict',
    },
    BatchJobRun: {
      NotFound: 'Nexo:Core:BatchJobRun:NotFound',
      ConcurrencyConflict: 'Nexo:Core:BatchJobRun:ConcurrencyConflict',
    },
    BusinessRule: {
      InvalidStateTransition: 'Nexo:Core:BusinessRule:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Core:BusinessRule:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Core:BusinessRule:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Core:BusinessRule:RuleExecutionFailed',
      NotFound: 'Nexo:Core:BusinessRule:NotFound',
      ConcurrencyConflict: 'Nexo:Core:BusinessRule:ConcurrencyConflict',
      DuplicateRuleNumber: 'Nexo:Core:BusinessRule:DuplicateRuleNumber',
    },
    CompanyProfile: {
      NotFound: 'Nexo:Core:CompanyProfile:NotFound',
      ConcurrencyConflict: 'Nexo:Core:CompanyProfile:ConcurrencyConflict',
      DuplicateOrgUnitId: 'Nexo:Core:CompanyProfile:DuplicateOrgUnitId',
    },
    Country: {
      NotFound: 'Nexo:Core:Country:NotFound',
      ConcurrencyConflict: 'Nexo:Core:Country:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:Country:DuplicateCode',
      DuplicateAlpha3Code: 'Nexo:Core:Country:DuplicateAlpha3Code',
    },
    Currency: {
      NotFound: 'Nexo:Core:Currency:NotFound',
      ConcurrencyConflict: 'Nexo:Core:Currency:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:Currency:DuplicateCode',
    },
    DeliveryTerms: {
      NotFound: 'Nexo:Core:DeliveryTerms:NotFound',
      ConcurrencyConflict: 'Nexo:Core:DeliveryTerms:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:DeliveryTerms:DuplicateCode',
    },
    DocumentPageSetup: {
      NotFound: 'Nexo:Core:DocumentPageSetup:NotFound',
      ConcurrencyConflict: 'Nexo:Core:DocumentPageSetup:ConcurrencyConflict',
    },
    DocumentTemplate: {
      NotFound: 'Nexo:Core:DocumentTemplate:NotFound',
      ConcurrencyConflict: 'Nexo:Core:DocumentTemplate:ConcurrencyConflict',
      NotSelectable: 'Nexo:Core:DocumentTemplate:NotSelectable',
    },
    EntityTemplate: {
      NotFound: 'Nexo:Core:EntityTemplate:NotFound',
      ConcurrencyConflict: 'Nexo:Core:EntityTemplate:ConcurrencyConflict',
      VisibilityNotAllowed: 'Nexo:Core:EntityTemplate:VisibilityNotAllowed',
      DefaultNotAllowed: 'Nexo:Core:EntityTemplate:DefaultNotAllowed',
    },
    EnumValue: {
      NotFound: 'Nexo:Core:EnumValue:NotFound',
      ConcurrencyConflict: 'Nexo:Core:EnumValue:ConcurrencyConflict',
    },
    FieldRestrictionEntry: {
      NotFound: 'Nexo:Core:FieldRestrictionEntry:NotFound',
      ConcurrencyConflict: 'Nexo:Core:FieldRestrictionEntry:ConcurrencyConflict',
    },
    FieldRestrictionSet: {
      NotFound: 'Nexo:Core:FieldRestrictionSet:NotFound',
      ConcurrencyConflict: 'Nexo:Core:FieldRestrictionSet:ConcurrencyConflict',
    },
    LldDistrict: {
      NotFound: 'Nexo:Core:LldDistrict:NotFound',
      ConcurrencyConflict: 'Nexo:Core:LldDistrict:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:LldDistrict:DuplicateCode',
    },
    NumberSeries: {
      NotFound: 'Nexo:Core:NumberSeries:NotFound',
      ConcurrencyConflict: 'Nexo:Core:NumberSeries:ConcurrencyConflict',
    },
    OrgRoleFunction: {
      NotFound: 'Nexo:Core:OrgRoleFunction:NotFound',
      ConcurrencyConflict: 'Nexo:Core:OrgRoleFunction:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:OrgRoleFunction:DuplicateCode',
    },
    OrgUnit: {
      NotFound: 'Nexo:Core:OrgUnit:NotFound',
      ConcurrencyConflict: 'Nexo:Core:OrgUnit:ConcurrencyConflict',
      CycleDetected: 'Nexo:Core:OrgUnit:CycleDetected',
      HasChildrenCannotDelete: 'Nexo:Core:OrgUnit:HasChildrenCannotDelete',
      MemberInvalidValidityRange: 'Nexo:Core:OrgUnit:MemberInvalidValidityRange',
      InUseCannotDelete: 'Nexo:Core:OrgUnit:InUseCannotDelete',
      DuplicateCode: 'Nexo:Core:OrgUnit:DuplicateCode',
    },
    OwnerDerivationRule: {
      NotFound: 'Nexo:Core:OwnerDerivationRule:NotFound',
      ConcurrencyConflict: 'Nexo:Core:OwnerDerivationRule:ConcurrencyConflict',
    },
    PaymentTerms: {
      NotFound: 'Nexo:Core:PaymentTerms:NotFound',
      ConcurrencyConflict: 'Nexo:Core:PaymentTerms:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:PaymentTerms:DuplicateCode',
    },
    ReceivingLocation: {
      NotFound: 'Nexo:Core:ReceivingLocation:NotFound',
      ConcurrencyConflict: 'Nexo:Core:ReceivingLocation:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:ReceivingLocation:DuplicateCode',
    },
    SetupPackage: {
      NotFound: 'Nexo:Core:SetupPackage:NotFound',
      ConcurrencyConflict: 'Nexo:Core:SetupPackage:ConcurrencyConflict',
      BuilderNotFound: 'Nexo:Core:SetupPackage:BuilderNotFound',
      PackageIsEmpty: 'Nexo:Core:SetupPackage:PackageIsEmpty',
      UnsupportedSchemaVersion: 'Nexo:Core:SetupPackage:UnsupportedSchemaVersion',
      IntegrityCheckFailed: 'Nexo:Core:SetupPackage:IntegrityCheckFailed',
      UnresolvableReference: 'Nexo:Core:SetupPackage:UnresolvableReference',
      SecretInPayload: 'Nexo:Core:SetupPackage:SecretInPayload',
    },
    TradeType: {
      NotFound: 'Nexo:Core:TradeType:NotFound',
      ConcurrencyConflict: 'Nexo:Core:TradeType:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:TradeType:DuplicateCode',
    },
    UnitOfMeasure: {
      NotFound: 'Nexo:Core:UnitOfMeasure:NotFound',
      ConcurrencyConflict: 'Nexo:Core:UnitOfMeasure:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:UnitOfMeasure:DuplicateCode',
    },
    UnitOfMeasureConversion: {
      NotFound: 'Nexo:Core:UnitOfMeasureConversion:NotFound',
      ConcurrencyConflict: 'Nexo:Core:UnitOfMeasureConversion:ConcurrencyConflict',
    },
  },
  Pricing: {
    BasePrice: {
      NotFound: 'Nexo:Pricing:BasePrice:NotFound',
      ConcurrencyConflict: 'Nexo:Pricing:BasePrice:ConcurrencyConflict',
    },
    InternalPriceLine: {
      NotFound: 'Nexo:Pricing:InternalPriceLine:NotFound',
      ConcurrencyConflict: 'Nexo:Pricing:InternalPriceLine:ConcurrencyConflict',
    },
    InternalPriceList: {
      NotFound: 'Nexo:Pricing:InternalPriceList:NotFound',
      ConcurrencyConflict: 'Nexo:Pricing:InternalPriceList:ConcurrencyConflict',
      InvalidValidityPeriod: 'Nexo:Pricing:InternalPriceList:InvalidValidityPeriod',
      DuplicateLine: 'Nexo:Pricing:InternalPriceList:DuplicateLine',
      OverlappingLine: 'Nexo:Pricing:InternalPriceList:OverlappingLine',
      DuplicateCode: 'Nexo:Pricing:InternalPriceList:DuplicateCode',
    },
    PriceList: {
      InvalidStateTransition: 'Nexo:Pricing:PriceList:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Pricing:PriceList:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Pricing:PriceList:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Pricing:PriceList:RuleExecutionFailed',
      NotFound: 'Nexo:Pricing:PriceList:NotFound',
      ConcurrencyConflict: 'Nexo:Pricing:PriceList:ConcurrencyConflict',
      DuplicateRow: 'Nexo:Pricing:PriceList:DuplicateRow',
      ProductXorProductGroup: 'Nexo:Pricing:PriceList:ProductXorProductGroup',
      RowDoesNotFitListType: 'Nexo:Pricing:PriceList:RowDoesNotFitListType',
      ClassSetsOnCalculationListsOnly: 'Nexo:Pricing:PriceList:ClassSetsOnCalculationListsOnly',
      MoreThanOneAddOnDimension: 'Nexo:Pricing:PriceList:MoreThanOneAddOnDimension',
      ClassesNotInChosenSets: 'Nexo:Pricing:PriceList:ClassesNotInChosenSets',
      DuplicatePriceListCode: 'Nexo:Pricing:PriceList:DuplicatePriceListCode',
    },
    PriceListClassSet: {
      NotFound: 'Nexo:Pricing:PriceListClassSet:NotFound',
      ConcurrencyConflict: 'Nexo:Pricing:PriceListClassSet:ConcurrencyConflict',
    },
  },
  Sales: {
    Customer: {
      NotFound: 'Nexo:Sales:Customer:NotFound',
      ConcurrencyConflict: 'Nexo:Sales:Customer:ConcurrencyConflict',
      DuplicateCustomerNumber: 'Nexo:Sales:Customer:DuplicateCustomerNumber',
    },
    CustomerGroup: {
      NotFound: 'Nexo:Sales:CustomerGroup:NotFound',
      ConcurrencyConflict: 'Nexo:Sales:CustomerGroup:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Sales:CustomerGroup:DuplicateCode',
    },
    Invoice: {
      InvalidStateTransition: 'Nexo:Sales:Invoice:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Sales:Invoice:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Sales:Invoice:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Sales:Invoice:RuleExecutionFailed',
      NotFound: 'Nexo:Sales:Invoice:NotFound',
      ConcurrencyConflict: 'Nexo:Sales:Invoice:ConcurrencyConflict',
      DuplicateInvoiceNumber: 'Nexo:Sales:Invoice:DuplicateInvoiceNumber',
    },
    InvoiceLine: {
      NotFound: 'Nexo:Sales:InvoiceLine:NotFound',
      ConcurrencyConflict: 'Nexo:Sales:InvoiceLine:ConcurrencyConflict',
    },
    Order: {
      InvalidStateTransition: 'Nexo:Sales:Order:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Sales:Order:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Sales:Order:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Sales:Order:RuleExecutionFailed',
      NotFound: 'Nexo:Sales:Order:NotFound',
      ConcurrencyConflict: 'Nexo:Sales:Order:ConcurrencyConflict',
      CommercialTermsFrozenAfterConfirmation: 'Nexo:Sales:Order:CommercialTermsFrozenAfterConfirmation',
      TotalFrozenAfterConfirmation: 'Nexo:Sales:Order:TotalFrozenAfterConfirmation',
      DeliveryDateCannotMoveEarlier: 'Nexo:Sales:Order:DeliveryDateCannotMoveEarlier',
      LinesCannotBeRemovedAfterConfirmation: 'Nexo:Sales:Order:LinesCannotBeRemovedAfterConfirmation',
      DuplicateOrderNumber: 'Nexo:Sales:Order:DuplicateOrderNumber',
    },
    OrderLine: {
      NotFound: 'Nexo:Sales:OrderLine:NotFound',
      ConcurrencyConflict: 'Nexo:Sales:OrderLine:ConcurrencyConflict',
    },
  },
  Integration: {
    ImportProfile: {
      NotFound: 'Nexo:Integration:ImportProfile:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:ImportProfile:ConcurrencyConflict',
    },
    IntegrationCallRecord: {
      NotFound: 'Nexo:Integration:IntegrationCallRecord:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationCallRecord:ConcurrencyConflict',
      NoActiveCallJob: 'Nexo:Integration:IntegrationCallRecord:NoActiveCallJob',
      CallAlreadyPending: 'Nexo:Integration:IntegrationCallRecord:CallAlreadyPending',
      ReparseRequiresAnswer: 'Nexo:Integration:IntegrationCallRecord:ReparseRequiresAnswer',
      ReapplyRequiresUnappliedOutcome: 'Nexo:Integration:IntegrationCallRecord:ReapplyRequiresUnappliedOutcome',
      MarkFailedRequiresOpenRecord: 'Nexo:Integration:IntegrationCallRecord:MarkFailedRequiresOpenRecord',
      RetryRequiresTransportFailure: 'Nexo:Integration:IntegrationCallRecord:RetryRequiresTransportFailure',
    },
    IntegrationClient: {
      NotFound: 'Nexo:Integration:IntegrationClient:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationClient:ConcurrencyConflict',
      DuplicateName: 'Nexo:Integration:IntegrationClient:DuplicateName',
    },
    IntegrationClientGrant: {
      NotFound: 'Nexo:Integration:IntegrationClientGrant:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationClientGrant:ConcurrencyConflict',
    },
    IntegrationConnection: {
      NotFound: 'Nexo:Integration:IntegrationConnection:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationConnection:ConcurrencyConflict',
      DuplicateName: 'Nexo:Integration:IntegrationConnection:DuplicateName',
    },
    IntegrationJob: {
      NotFound: 'Nexo:Integration:IntegrationJob:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationJob:ConcurrencyConflict',
      DuplicateName: 'Nexo:Integration:IntegrationJob:DuplicateName',
      DuplicateInboundMessageType: 'Nexo:Integration:IntegrationJob:DuplicateInboundMessageType',
    },
    IntegrationOutboxRecord: {
      NotFound: 'Nexo:Integration:IntegrationOutboxRecord:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationOutboxRecord:ConcurrencyConflict',
      RetryBlockedByDeliveryInFlight: 'Nexo:Integration:IntegrationOutboxRecord:RetryBlockedByDeliveryInFlight',
      DownloadRequiresProducedFile: 'Nexo:Integration:IntegrationOutboxRecord:DownloadRequiresProducedFile',
      AcknowledgedVersionCannotBeResent: 'Nexo:Integration:IntegrationOutboxRecord:AcknowledgedVersionCannotBeResent',
      AcknowledgementAlreadyApplied: 'Nexo:Integration:IntegrationOutboxRecord:AcknowledgementAlreadyApplied',
      DocumentVersionChanged: 'Nexo:Integration:IntegrationOutboxRecord:DocumentVersionChanged',
    },
    IntegrationRun: {
      NotFound: 'Nexo:Integration:IntegrationRun:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationRun:ConcurrencyConflict',
      OnlineImportRunning: 'Nexo:Integration:IntegrationRun:OnlineImportRunning',
    },
    IntegrationStagingRecord: {
      NotFound: 'Nexo:Integration:IntegrationStagingRecord:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationStagingRecord:ConcurrencyConflict',
    },
  },
  Procurement: {
    InboundMeasuringTicket: {
      NotFound: 'Nexo:Procurement:InboundMeasuringTicket:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:InboundMeasuringTicket:ConcurrencyConflict',
      AlreadyReceived: 'Nexo:Procurement:InboundMeasuringTicket:AlreadyReceived',
    },
    InboundMeasuringTicketLine: {
      NotFound: 'Nexo:Procurement:InboundMeasuringTicketLine:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:InboundMeasuringTicketLine:ConcurrencyConflict',
    },
    Supplier: {
      NotFound: 'Nexo:Procurement:Supplier:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:Supplier:ConcurrencyConflict',
      MultiplePrimaryBankAccounts: 'Nexo:Procurement:Supplier:MultiplePrimaryBankAccounts',
      DuplicateSupplierNumber: 'Nexo:Procurement:Supplier:DuplicateSupplierNumber',
    },
    SupplierAddress: {
      NotFound: 'Nexo:Procurement:SupplierAddress:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:SupplierAddress:ConcurrencyConflict',
    },
    SupplierBankAccount: {
      NotFound: 'Nexo:Procurement:SupplierBankAccount:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:SupplierBankAccount:ConcurrencyConflict',
    },
    SupplierContact: {
      NotFound: 'Nexo:Procurement:SupplierContact:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:SupplierContact:ConcurrencyConflict',
    },
  },
  Inventory: {
    InventoryPeriodClose: {
      NotFound: 'Nexo:Inventory:InventoryPeriodClose:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:InventoryPeriodClose:ConcurrencyConflict',
    },
    InventoryPostingProfile: {
      NotFound: 'Nexo:Inventory:InventoryPostingProfile:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:InventoryPostingProfile:ConcurrencyConflict',
    },
    InventoryReservation: {
      NotFound: 'Nexo:Inventory:InventoryReservation:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:InventoryReservation:ConcurrencyConflict',
    },
    InventoryTransaction: {
      InvalidStateTransition: 'Nexo:Inventory:InventoryTransaction:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Inventory:InventoryTransaction:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Inventory:InventoryTransaction:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Inventory:InventoryTransaction:RuleExecutionFailed',
      NotFound: 'Nexo:Inventory:InventoryTransaction:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:InventoryTransaction:ConcurrencyConflict',
      ReceiptQuantityNotPositive: 'Nexo:Inventory:InventoryTransaction:ReceiptQuantityNotPositive',
    },
    Product: {
      NotFound: 'Nexo:Inventory:Product:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:Product:ConcurrencyConflict',
      DuplicateProductNumber: 'Nexo:Inventory:Product:DuplicateProductNumber',
    },
    ProductGroup: {
      NotFound: 'Nexo:Inventory:ProductGroup:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:ProductGroup:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Inventory:ProductGroup:DuplicateCode',
    },
    StandardCostPrice: {
      NotFound: 'Nexo:Inventory:StandardCostPrice:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:StandardCostPrice:ConcurrencyConflict',
    },
    StandardCostVersion: {
      InvalidStateTransition: 'Nexo:Inventory:StandardCostVersion:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Inventory:StandardCostVersion:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Inventory:StandardCostVersion:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Inventory:StandardCostVersion:RuleExecutionFailed',
      NotFound: 'Nexo:Inventory:StandardCostVersion:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:StandardCostVersion:ConcurrencyConflict',
    },
  },
  TaskManagement: {
    WorkTask: {
      InvalidStateTransition: 'Nexo:TaskManagement:WorkTask:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:TaskManagement:WorkTask:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:TaskManagement:WorkTask:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:TaskManagement:WorkTask:RuleExecutionFailed',
      NotFound: 'Nexo:TaskManagement:WorkTask:NotFound',
      ConcurrencyConflict: 'Nexo:TaskManagement:WorkTask:ConcurrencyConflict',
    },
  },
} as const;

/** Default user-facing messages (fallback when backend message is empty) */
export const ErrorMessages: Record<string, string> = {
  'Nexo:Finance:Account:NotFound': 'Account not found',
  'Nexo:Finance:Account:ConcurrencyConflict': 'Account was modified by another user. Please refresh and try again',
  'Nexo:Finance:Account:DuplicateAccountNumber': 'A Account with the same account number already exists.',
  'Nexo:Finance:AccountDerivationRule:NotFound': 'AccountDerivationRule not found',
  'Nexo:Finance:AccountDerivationRule:ConcurrencyConflict': 'AccountDerivationRule was modified by another user. Please refresh and try again',
  'Nexo:Finance:AccountDimensionRule:NotFound': 'AccountDimensionRule not found',
  'Nexo:Finance:AccountDimensionRule:ConcurrencyConflict': 'AccountDimensionRule was modified by another user. Please refresh and try again',
  'Nexo:Finance:AccountGroup:NotFound': 'AccountGroup not found',
  'Nexo:Finance:AccountGroup:ConcurrencyConflict': 'AccountGroup was modified by another user. Please refresh and try again',
  'Nexo:Finance:DimensionDefinition:NotFound': 'DimensionDefinition not found',
  'Nexo:Finance:DimensionDefinition:ConcurrencyConflict': 'DimensionDefinition was modified by another user. Please refresh and try again',
  'Nexo:Finance:DimensionDefinition:DuplicateCode': 'A DimensionDefinition with the same code already exists.',
  'Nexo:Finance:DimensionDefinition:DuplicateName': 'A DimensionDefinition with the same name already exists.',
  'Nexo:Finance:DimensionDefinitionModule:NotFound': 'DimensionDefinitionModule not found',
  'Nexo:Finance:DimensionDefinitionModule:ConcurrencyConflict': 'DimensionDefinitionModule was modified by another user. Please refresh and try again',
  'Nexo:Finance:DimensionSet:NotFound': 'DimensionSet not found',
  'Nexo:Finance:DimensionSet:ConcurrencyConflict': 'DimensionSet was modified by another user. Please refresh and try again',
  'Nexo:Finance:DimensionSet:DuplicateHash': 'A DimensionSet with the same hash already exists.',
  'Nexo:Finance:DimensionValue:NotFound': 'DimensionValue not found',
  'Nexo:Finance:DimensionValue:ConcurrencyConflict': 'DimensionValue was modified by another user. Please refresh and try again',
  'Nexo:Finance:DimensionValue:InUseCannotDelete': 'The dimension value \'{name}\' cannot be deleted — it is still in use: {usages}. Deactivate it instead, or remove the references first.',
  'Nexo:Finance:DistributionProfile:NotFound': 'DistributionProfile not found',
  'Nexo:Finance:DistributionProfile:ConcurrencyConflict': 'DistributionProfile was modified by another user. Please refresh and try again',
  'Nexo:Finance:DistributionProfileLine:NotFound': 'DistributionProfileLine not found',
  'Nexo:Finance:DistributionProfileLine:ConcurrencyConflict': 'DistributionProfileLine was modified by another user. Please refresh and try again',
  'Nexo:Finance:FiscalPeriod:InvalidStateTransition': 'Cannot transition FiscalPeriod from {currentStatus} to {targetStatus}',
  'Nexo:Finance:FiscalPeriod:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Finance:FiscalPeriod:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Finance:FiscalPeriod:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Finance:FiscalPeriod:NotFound': 'FiscalPeriod not found',
  'Nexo:Finance:FiscalPeriod:ConcurrencyConflict': 'FiscalPeriod was modified by another user. Please refresh and try again',
  'Nexo:Finance:FiscalYear:NotFound': 'FiscalYear not found',
  'Nexo:Finance:FiscalYear:ConcurrencyConflict': 'FiscalYear was modified by another user. Please refresh and try again',
  'Nexo:Finance:FiscalYear:DuplicateCode': 'A FiscalYear with the same code already exists.',
  'Nexo:Finance:Measure:NotFound': 'Measure not found',
  'Nexo:Finance:Measure:ConcurrencyConflict': 'Measure was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanAllocation:NotFound': 'PlanAllocation not found',
  'Nexo:Finance:PlanAllocation:ConcurrencyConflict': 'PlanAllocation was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanHeader:InvalidStateTransition': 'Cannot transition PlanHeader from {currentStatus} to {targetStatus}',
  'Nexo:Finance:PlanHeader:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Finance:PlanHeader:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Finance:PlanHeader:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Finance:PlanHeader:NotFound': 'PlanHeader not found',
  'Nexo:Finance:PlanHeader:ConcurrencyConflict': 'PlanHeader was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanHeader:ScopePinCollidesWithRowAxis': 'The dimension \'{dimension}\' cannot be pinned on this plan header: it is an entity-backed row axis of the plan view \'{planView}\', so the pin would override every row\'s value when cells are saved. Remove the pin, or choose a plan view where the dimension is not a row axis.',
  'Nexo:Finance:PlanHeader:SubmitBlockedByEmptyHeader': 'This plan header cannot be submitted: it has no plan lines. Enter at least one value before handing it in for review.',
  'Nexo:Finance:PlanHeader:SubmitRequiresRowAccess': 'This plan header is assigned to someone else and is not under an org node you manage, so you cannot hand it in.',
  'Nexo:Finance:PlanHeader:ReturnRequiresApprovingCapacity': 'Only the owner of this plan header, or someone who manages its part of the org tree, can send it back.',
  'Nexo:Finance:PlanHeader:ReevaluateRequiresEditableStatus': 'This plan header is not in Draft or Returned and was skipped. Return it before re-evaluating its lines.',
  'Nexo:Finance:PlanHeader:ReevaluateRequiresEditableVersion': 'The plan version of this header is frozen or being published, so the header was skipped.',
  'Nexo:Finance:PlanHeader:ReevaluateAlreadyRunning': 'A re-evaluation is already running for this plan header, so it was skipped.',
  'Nexo:Finance:PlanHeader:ReevaluateNothingEligible': 'None of the selected plan headers can be re-evaluated: they are not in Draft or Returned, their version is frozen, or a re-evaluation is already running.',
  'Nexo:Finance:PlanHeader:EntryBlockedWhileReevaluating': 'This plan header is being re-evaluated. Entry reopens when the run completes.',
  'Nexo:Finance:PlanHeader:ReevaluateSelectionContested': 'Another re-evaluation was started for one of the selected plan headers at the same moment. Retry — headers already in a run are skipped.',
  'Nexo:Finance:PlanHeaderScope:NotFound': 'PlanHeaderScope not found',
  'Nexo:Finance:PlanHeaderScope:ConcurrencyConflict': 'PlanHeaderScope was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanLine:NotFound': 'PlanLine not found',
  'Nexo:Finance:PlanLine:ConcurrencyConflict': 'PlanLine was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanLineReevaluationRun:NotFound': 'PlanLineReevaluationRun not found',
  'Nexo:Finance:PlanLineReevaluationRun:ConcurrencyConflict': 'PlanLineReevaluationRun was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanLineReevaluationRun:SystemProduced': 'Re-evaluation runs are created by the Re-evaluate lines action and cannot be created or edited by hand.',
  'Nexo:Finance:PlanLineReevaluationRun:DuplicateRunNumber': 'A PlanLineReevaluationRun with the same run number already exists.',
  'Nexo:Finance:PlanScenario:NotFound': 'PlanScenario not found',
  'Nexo:Finance:PlanScenario:ConcurrencyConflict': 'PlanScenario was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanScenario:ScenarioCodeConflict': 'A plan scenario with this code already exists in the legal entity.',
  'Nexo:Finance:PlanScenario:SourceScenarioHasNoVersions': 'The source scenario has no versions to copy the structure from.',
  'Nexo:Finance:PlanScenario:SourceVersionNotInScenario': 'The selected source version does not belong to the source scenario.',
  'Nexo:Finance:PlanScenario:InvalidScenarioType': 'The scenario type is not recognized.',
  'Nexo:Finance:PlanScenario:TargetFiscalYearNotFound': 'The selected fiscal year does not exist.',
  'Nexo:Finance:PlanStatementRow:NotFound': 'PlanStatementRow not found',
  'Nexo:Finance:PlanStatementRow:ConcurrencyConflict': 'PlanStatementRow was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanStatementTemplate:NotFound': 'PlanStatementTemplate not found',
  'Nexo:Finance:PlanStatementTemplate:ConcurrencyConflict': 'PlanStatementTemplate was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanStatementTemplate:DuplicateRowCode': 'Row code "{rowCode}" is used more than once. Each row of a statement must have a unique code.',
  'Nexo:Finance:PlanStatementTemplate:FormulaUnknownReference': 'The formula on the row "{rowCode}" refers to "{reference}", which is not a row of this statement that carries a figure. Use the row code of an account set or calculation row.',
  'Nexo:Finance:PlanStatementTemplate:PercentOfUnknownReference': 'The row "{rowCode}" is set to show as a percentage of "{reference}", which is not a row of this statement that carries a figure. Use the row code of an account set or calculation row.',
  'Nexo:Finance:PlanStatementTemplate:FormulaCycle': 'These rows refer to each other in a loop and can never be computed: {rows}. Break the loop before saving.',
  'Nexo:Finance:PlanVersion:InvalidStateTransition': 'Cannot transition PlanVersion from {currentStatus} to {targetStatus}',
  'Nexo:Finance:PlanVersion:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Finance:PlanVersion:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Finance:PlanVersion:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Finance:PlanVersion:NotFound': 'PlanVersion not found',
  'Nexo:Finance:PlanVersion:ConcurrencyConflict': 'PlanVersion was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanVersion:BudgetPublishRequiresApprovedState': 'A budget version can only be published from the Approved state.',
  'Nexo:Finance:PlanVersion:WhatIfCannotBePublished': 'What-if scenarios are exploratory and can never be published.',
  'Nexo:Finance:PlanVersion:PublishBlockedByLockedVersion': 'A locked version exists in this scenario. Archive the locked version before publishing.',
  'Nexo:Finance:PlanVersion:VersionNumberConflict': 'Another version was created in this scenario at the same time. Try again.',
  'Nexo:Finance:PlanVersion:PublishRequiresLines': 'The version has no plan lines to publish.',
  'Nexo:Finance:PlanVersion:PublishBlockedByPendingLines': 'The version has unresolved plan lines. Resolve or remove pending lines before publishing.',
  'Nexo:Finance:PlanVersion:PublishAlreadyInProgress': 'A publish is already in progress for this version.',
  'Nexo:Finance:PlanVersion:PublishBlockedByReevaluation': 'A plan-line re-evaluation is in progress for a header of this version. Publish when it has completed.',
  'Nexo:Finance:PlanVersion:PublishBlockedByMissingReference': 'An account or dimension set referenced by plan lines no longer exists. Re-map the affected lines before publishing.',
  'Nexo:Finance:PlanVersion:SubmitBlockedByUnsubmittedHeaders': 'Every plan header that contains lines must be submitted before the version can be handed in for review.',
  'Nexo:Finance:PlanVersion:ApprovalPending': 'An approval request is open for this version. Its outcome decides the version — approve or return it from your task inbox.',
  'Nexo:Finance:PlanVersion:SubmitRequiresBudgetScenario': 'Only a budget version is handed in for review. A forecast version is published directly, and a what-if version is never published.',
  'Nexo:Finance:PlanVersionPublishRun:NotFound': 'PlanVersionPublishRun not found',
  'Nexo:Finance:PlanVersionPublishRun:ConcurrencyConflict': 'PlanVersionPublishRun was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanView:NotFound': 'PlanView not found',
  'Nexo:Finance:PlanView:ConcurrencyConflict': 'PlanView was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanView:MeasureFormulaRequiresDerivedKind': 'The measure \'{measure}\' has a formula but its kind is Input. Only a derived measure is calculated from a formula. Set the kind to Derived, or clear the formula.',
  'Nexo:Finance:PlanView:DerivedAmountRequiresFormula': 'The measure \'{measure}\' is derived and stored as the amount of the plan line, but has no formula. A derived amount is calculated from its formula: write one, for example VOLUME * PRICE.',
  'Nexo:Finance:PlanView:MeasureWeightInvalid': 'The measure \'{measure}\' cannot be weighted by \'{weightedBy}\': only an entered rate or ratio is weighted, and only by a quantity or amount measure of the same view.',
  'Nexo:Finance:PlanView:MeasuresFrozenByPublishedVersion': 'The measure \'{measure}\' cannot be changed or removed: the published version \'{version}\' is computed with it. Copy the plan view to plan with another definition.',
  'Nexo:Finance:PlanView:MeasuresFrozenBySubmittedHeader': 'The measure \'{measure}\' cannot be changed or removed: the plan \'{header}\' made with this view has been submitted. Copy the plan view to plan with another definition.',
  'Nexo:Finance:PlanView:MeasureChangedAfterFiguresEntered': 'Figures have already been entered with the measure \'{measure}\': {lines} plan lines in {headers} plans. They keep their values until the plan lines are re-evaluated.',
  'Nexo:Finance:PlanView:MeasureFormulaCycle': 'The measures {measures} refer to each other in a circle through their formulas, so none of them can be calculated. Break the loop by removing one of the references.',
  'Nexo:Finance:PlanView:StorageBindingNotValidForKind': 'The measure \'{measure}\' is stored as {binding}, which a {kind} measure cannot use — an entered value needs a destination the grid can write to, a calculated one needs a destination with a writer of its own. A {kind} measure can be stored as: {allowed}.',
  'Nexo:Finance:PlanView:MeasureFormulaInvalid': 'The formula of measure \'{measure}\' is not valid: {detail}',
  'Nexo:Finance:PlanView:MeasureResultOutOfRange': 'The measure \'{measure}\' cannot be computed for this cell: its value lies outside the range a number can hold. Check the values it is computed from.',
  'Nexo:Finance:PlanView:DuplicateRowAxis': 'A row axis can be used only once per root node. Two row axes with the same source must point at different root nodes. Remove the duplicate before saving.',
  'Nexo:Finance:PlanView:DuplicateMeasureCode': 'Measure code \'{code}\' is used more than once. Each measure on a view must have a unique code.',
  'Nexo:Finance:PlanView:DuplicateFixedStorageBinding': 'Only one measure can use the \'{binding}\' storage binding — it holds one value per cell, so a second measure would overwrite the first on save. Use the Driver binding for additional input measures, or Computed for derived (display-only) measures.',
  'Nexo:Finance:PlanViewRowDimension:NotFound': 'PlanViewRowDimension not found',
  'Nexo:Finance:PlanViewRowDimension:ConcurrencyConflict': 'PlanViewRowDimension was modified by another user. Please refresh and try again',
  'Nexo:Finance:VatCode:NotFound': 'VatCode not found',
  'Nexo:Finance:VatCode:ConcurrencyConflict': 'VatCode was modified by another user. Please refresh and try again',
  'Nexo:Finance:VatCode:DuplicateCode': 'A VatCode with the same code already exists.',
  'Nexo:Forestry:Agreement:InvalidStateTransition': 'Cannot transition Agreement from {currentStatus} to {targetStatus}',
  'Nexo:Forestry:Agreement:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Forestry:Agreement:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Forestry:Agreement:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Forestry:Agreement:NotFound': 'Agreement not found',
  'Nexo:Forestry:Agreement:ConcurrencyConflict': 'Agreement was modified by another user. Please refresh and try again',
  'Nexo:Forestry:Agreement:DuplicateAgreementNumber': 'A Agreement with the same agreement no. already exists.',
  'Nexo:Forestry:CalculationComponent:NotFound': 'CalculationComponent not found',
  'Nexo:Forestry:CalculationComponent:ConcurrencyConflict': 'CalculationComponent was modified by another user. Please refresh and try again',
  'Nexo:Forestry:CalculationComponent:ValueSideHasNoCostType': 'A value-side component has no cost type.',
  'Nexo:Forestry:CalculationComponent:PerQuantityRequiresUnit': 'A per-quantity component needs a unit.',
  'Nexo:Forestry:CalculationComponent:PercentRequiresOtherBasis': 'A percent component cannot be a percentage of itself.',
  'Nexo:Forestry:CalculationComponent:ValueSideFromPriceList': 'A value-side component takes its price from the price list.',
  'Nexo:Forestry:CalculationComponent:ChargeOnlyOnCost': 'Only a cost-side component has a charge component.',
  'Nexo:Forestry:CalculationComponent:ChangedInActivatedTemplate': 'The component is used by an activated calculation template: changing its {fields} applies to every version that uses it, active ones included.',
  'Nexo:Forestry:CalculationComponent:DuplicateCode': 'A CalculationComponent with the same code already exists.',
  'Nexo:Forestry:CalculationComponentAllocationProductGroup:NotFound': 'CalculationComponentAllocationProductGroup not found',
  'Nexo:Forestry:CalculationComponentAllocationProductGroup:ConcurrencyConflict': 'CalculationComponentAllocationProductGroup was modified by another user. Please refresh and try again',
  'Nexo:Forestry:CalculationTemplate:NotFound': 'CalculationTemplate not found',
  'Nexo:Forestry:CalculationTemplate:ConcurrencyConflict': 'CalculationTemplate was modified by another user. Please refresh and try again',
  'Nexo:Forestry:CalculationTemplate:DuplicateTradeTypeId': 'A CalculationTemplate with the same trade type already exists.',
  'Nexo:Forestry:CalculationTemplateLine:NotFound': 'CalculationTemplateLine not found',
  'Nexo:Forestry:CalculationTemplateLine:ConcurrencyConflict': 'CalculationTemplateLine was modified by another user. Please refresh and try again',
  'Nexo:Forestry:CalculationTemplateLine:TemplateLineIsImmutable': 'The lines of an active or superseded template version cannot be changed; edit a draft.',
  'Nexo:Forestry:CalculationTemplateLine:FormulaOnlyForFormulaComponent': 'A formula is only allowed on a formula component and must be valid.',
  'Nexo:Forestry:CalculationTemplateLine:DefaultValueOnlyForManualComponent': 'A default value is only allowed on a manual component.',
  'Nexo:Forestry:CalculationTemplateLine:QuantitySourceMismatch': 'A lump-sum line has no quantity source; every other line needs one.',
  'Nexo:Forestry:CalculationTemplateLine:ValueSideLineHasNoScope': 'A value-side line has no product-group scope; the price list decides which product groups it prices.',
  'Nexo:Forestry:CalculationTemplateLine:DefaultChargeMismatch': 'A cost line needs a default charge that fits its component, and no other line has one.',
  'Nexo:Forestry:CalculationTemplateLineProductGroup:NotFound': 'CalculationTemplateLineProductGroup not found',
  'Nexo:Forestry:CalculationTemplateLineProductGroup:ConcurrencyConflict': 'CalculationTemplateLineProductGroup was modified by another user. Please refresh and try again',
  'Nexo:Forestry:CalculationTemplateVersion:InvalidStateTransition': 'Cannot transition CalculationTemplateVersion from {currentStatus} to {targetStatus}',
  'Nexo:Forestry:CalculationTemplateVersion:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Forestry:CalculationTemplateVersion:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Forestry:CalculationTemplateVersion:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Forestry:CalculationTemplateVersion:NotFound': 'CalculationTemplateVersion not found',
  'Nexo:Forestry:CalculationTemplateVersion:ConcurrencyConflict': 'CalculationTemplateVersion was modified by another user. Please refresh and try again',
  'Nexo:Forestry:CalculationTemplateVersion:TemplateVersionIsImmutable': 'An active or superseded template version cannot be changed; edit a draft.',
  'Nexo:Forestry:CalculationTemplateVersion:TemplateVersionHasInvalidLines': 'The template version cannot be activated. {lines}',
  'Nexo:Forestry:CalculationTemplateVersion:TemplateVersionValidFromInvalid': 'Give the version a valid-from date of today or later, after the active version\'s, before activating it.',
  'Nexo:Forestry:Contract:NotFound': 'Contract not found',
  'Nexo:Forestry:Contract:ConcurrencyConflict': 'Contract was modified by another user. Please refresh and try again',
  'Nexo:Forestry:Contract:PriceAreasKeptOnceAgreementActive': 'The price areas of a contract whose agreement is active or closed cannot be updated.',
  'Nexo:Forestry:Contract:DuplicateContractNumber': 'A Contract with the same contract no. already exists.',
  'Nexo:Forestry:ContractArea:NotFound': 'ContractArea not found',
  'Nexo:Forestry:ContractArea:ConcurrencyConflict': 'ContractArea was modified by another user. Please refresh and try again',
  'Nexo:Forestry:ContractArea:TreeSpeciesSharesMustAddUpTo100': 'The shares of the tree species of an area must add up to 100 percent.',
  'Nexo:Forestry:ContractAreaTreeSpecies:NotFound': 'ContractAreaTreeSpecies not found',
  'Nexo:Forestry:ContractAreaTreeSpecies:ConcurrencyConflict': 'ContractAreaTreeSpecies was modified by another user. Please refresh and try again',
  'Nexo:Forestry:ContractCertificate:NotFound': 'ContractCertificate not found',
  'Nexo:Forestry:ContractCertificate:ConcurrencyConflict': 'ContractCertificate was modified by another user. Please refresh and try again',
  'Nexo:Forestry:ContractLineItem:NotFound': 'ContractLineItem not found',
  'Nexo:Forestry:ContractLineItem:ConcurrencyConflict': 'ContractLineItem was modified by another user. Please refresh and try again',
  'Nexo:Forestry:CostType:NotFound': 'CostType not found',
  'Nexo:Forestry:CostType:ConcurrencyConflict': 'CostType was modified by another user. Please refresh and try again',
  'Nexo:Forestry:CostType:DuplicateCode': 'A CostType with the same code already exists.',
  'Nexo:Forestry:LoadObservation:NotFound': 'LoadObservation not found',
  'Nexo:Forestry:LoadObservation:ConcurrencyConflict': 'LoadObservation was modified by another user. Please refresh and try again',
  'Nexo:Forestry:LoadObservationItem:NotFound': 'LoadObservationItem not found',
  'Nexo:Forestry:LoadObservationItem:ConcurrencyConflict': 'LoadObservationItem was modified by another user. Please refresh and try again',
  'Nexo:Forestry:Organization:NotFound': 'Organization not found',
  'Nexo:Forestry:Organization:ConcurrencyConflict': 'Organization was modified by another user. Please refresh and try again',
  'Nexo:Forestry:Organization:DuplicateOrganizationCode': 'A Organization with the same organization code already exists.',
  'Nexo:Forestry:PreCalculation:NotFound': 'PreCalculation not found',
  'Nexo:Forestry:PreCalculation:ConcurrencyConflict': 'PreCalculation was modified by another user. Please refresh and try again',
  'Nexo:Forestry:PreCalculation:ContractNotCalculable': 'The contract needs a trade type and a price area before it can be calculated.',
  'Nexo:Forestry:PreCalculation:NoActiveTemplateVersion': 'The calculation template of the trade type has no version in force on the price date {priceDate}.',
  'Nexo:Forestry:PreCalculation:DuplicatePreCalculationNumber': 'A PreCalculation with the same pre-calculation no. already exists.',
  'Nexo:Forestry:PreCalculationCostPost:NotFound': 'PreCalculationCostPost not found',
  'Nexo:Forestry:PreCalculationCostPost:ConcurrencyConflict': 'PreCalculationCostPost was modified by another user. Please refresh and try again',
  'Nexo:Forestry:PreCalculationCostPost:CostPostTotalNeedsTerm': 'The cost for the whole contract needs a charge term.',
  'Nexo:Forestry:PreCalculationCostPost:CostPostPriceOnlyWhenFixed': 'An agreed price is given only for a fixed amount.',
  'Nexo:Forestry:PreCalculationCostPost:CostPostFixedTotalNeedsPrice': 'A fixed amount for the whole contract needs an agreed price.',
  'Nexo:Forestry:PreCalculationCostPost:CostPostAreaTakesTotalTerm': 'A contract area is charged on the term of the whole contract.',
  'Nexo:Forestry:PreCalculationDriver:NotFound': 'PreCalculationDriver not found',
  'Nexo:Forestry:PreCalculationDriver:ConcurrencyConflict': 'PreCalculationDriver was modified by another user. Please refresh and try again',
  'Nexo:Forestry:PreCalculationLine:NotFound': 'PreCalculationLine not found',
  'Nexo:Forestry:PreCalculationLine:ConcurrencyConflict': 'PreCalculationLine was modified by another user. Please refresh and try again',
  'Nexo:Forestry:PriceAreaAssortment:NotFound': 'PriceAreaAssortment not found',
  'Nexo:Forestry:PriceAreaAssortment:ConcurrencyConflict': 'PriceAreaAssortment was modified by another user. Please refresh and try again',
  'Nexo:Forestry:PriceDimension:NotFound': 'PriceDimension not found',
  'Nexo:Forestry:PriceDimension:ConcurrencyConflict': 'PriceDimension was modified by another user. Please refresh and try again',
  'Nexo:Forestry:PriceDimension:DuplicateCode': 'A PriceDimension with the same code already exists.',
  'Nexo:Forestry:PriceDimension:DuplicateSortOrder': 'A PriceDimension with the same sort order already exists.',
  'Nexo:Forestry:PriceDimensionClass:NotFound': 'PriceDimensionClass not found',
  'Nexo:Forestry:PriceDimensionClass:ConcurrencyConflict': 'PriceDimensionClass was modified by another user. Please refresh and try again',
  'Nexo:Forestry:PriceDimensionClass:InvalidClassBounds': 'An interval class needs a lower bound and an upper bound above it, or no upper bound; a code class has no bounds.',
  'Nexo:Forestry:PriceDimensionClassCombination:NotFound': 'PriceDimensionClassCombination not found',
  'Nexo:Forestry:PriceDimensionClassCombination:ConcurrencyConflict': 'PriceDimensionClassCombination was modified by another user. Please refresh and try again',
  'Nexo:Forestry:PriceDimensionClassCombination:CombinationIsImmutable': 'A class combination cannot be changed; a line with other classes uses another combination.',
  'Nexo:Forestry:PriceDimensionClassCombination:MoreThanOneClassPerDimension': 'A class combination can have only one class per price dimension.',
  'Nexo:Forestry:PriceDimensionClassCombination:DuplicateHash': 'A PriceDimensionClassCombination with the same hash already exists.',
  'Nexo:Forestry:PriceDimensionClassSet:NotFound': 'PriceDimensionClassSet not found',
  'Nexo:Forestry:PriceDimensionClassSet:ConcurrencyConflict': 'PriceDimensionClassSet was modified by another user. Please refresh and try again',
  'Nexo:Forestry:PriceDimensionClassSet:IntervalClassesNotContiguous': 'The interval classes must follow each other without gaps or overlaps; only the last may be open upwards.',
  'Nexo:Forestry:SigningRow:InvalidStateTransition': 'Cannot transition SigningRow from {currentStatus} to {targetStatus}',
  'Nexo:Forestry:SigningRow:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Forestry:SigningRow:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Forestry:SigningRow:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Forestry:SigningRow:NotFound': 'SigningRow not found',
  'Nexo:Forestry:SigningRow:ConcurrencyConflict': 'SigningRow was modified by another user. Please refresh and try again',
  'Nexo:Forestry:SupplyPoint:NotFound': 'SupplyPoint not found',
  'Nexo:Forestry:SupplyPoint:ConcurrencyConflict': 'SupplyPoint was modified by another user. Please refresh and try again',
  'Nexo:Forestry:SupplyPoint:RouteDistanceRequiresCoordinates': 'A route distance needs the supply point\'s coordinate and the workorder\'s receiving location.',
  'Nexo:Forestry:SupplyPoint:RouteDistanceFailed': 'Krönt vägval could not calculate the route distance.',
  'Nexo:Forestry:SupplyPoint:DuplicateSupplyPointId': 'A SupplyPoint with the same supply point id already exists.',
  'Nexo:Forestry:VolumeBasisLine:NotFound': 'VolumeBasisLine not found',
  'Nexo:Forestry:VolumeBasisLine:ConcurrencyConflict': 'VolumeBasisLine was modified by another user. Please refresh and try again',
  'Nexo:Forestry:VolumeBasisLine:VolumeMustBeNonNegativeM3f': 'Volume must be zero or more, in m3f.',
  'Nexo:Forestry:VolumeBasisLine:ClassNotMeasuredOnBasisLine': 'A volume basis line can only carry classes of dimensions measured on the basis line.',
  'Nexo:Forestry:Workorder:NotFound': 'Workorder not found',
  'Nexo:Forestry:Workorder:ConcurrencyConflict': 'Workorder was modified by another user. Please refresh and try again',
  'Nexo:Forestry:Workorder:DuplicateWorkorderNumber': 'A Workorder with the same workorder no. already exists.',
  'Nexo:Forestry:Workorder:DuplicateDeliverySourceId': 'A Workorder with the same delivery source id already exists.',
  'Nexo:Forestry:WorkorderItem:NotFound': 'WorkorderItem not found',
  'Nexo:Forestry:WorkorderItem:ConcurrencyConflict': 'WorkorderItem was modified by another user. Please refresh and try again',
  'Nexo:Workflow:ApprovalDelegation:NotFound': 'ApprovalDelegation not found',
  'Nexo:Workflow:ApprovalDelegation:ConcurrencyConflict': 'ApprovalDelegation was modified by another user. Please refresh and try again',
  'Nexo:Workflow:ApprovalPolicy:NotFound': 'ApprovalPolicy not found',
  'Nexo:Workflow:ApprovalPolicy:ConcurrencyConflict': 'ApprovalPolicy was modified by another user. Please refresh and try again',
  'Nexo:Workflow:ApprovalPolicy:PolicyHasNoSteps': 'This approval policy has no steps, so there is nobody to approve. Add at least one step before enabling it.',
  'Nexo:Workflow:ApprovalPolicy:NoApproversResolved': 'The approval step resolved to nobody. Check that the approver reference points at a role someone currently holds.',
  'Nexo:Workflow:ApprovalPolicy:DuplicateOpenRequest': 'An approval request is already open for this record and action.',
  'Nexo:Workflow:ApprovalPolicy:StepMissingApprover': 'Step {stepName} is set to resolve a named approver but none is chosen. Pick who approves, or change the strategy.',
  'Nexo:Workflow:ApprovalPolicy:StepMissingPermission': 'Step {stepName} approves by permission but names none. Enter the permission whose holders may approve.',
  'Nexo:Workflow:ApprovalPolicy:StepMissingQuorumCount': 'Step {stepName} needs a quorum but no number of approvals. Enter how many approvals it takes.',
  'Nexo:Workflow:ApprovalPolicy:UnsupportedAssignmentStrategy': 'Step {stepName} uses an assignment strategy this version cannot resolve. Choose Specific user, Permission, Org unit role or Manager of.',
  'Nexo:Workflow:ApprovalPolicy:PolicyEntityTypeMismatch': 'This approval policy is for {policyEntityType}, not {entityType}. Approval was not started — pick a policy for this kind of record.',
  'Nexo:Workflow:ApprovalPolicyStep:NotFound': 'ApprovalPolicyStep not found',
  'Nexo:Workflow:ApprovalPolicyStep:ConcurrencyConflict': 'ApprovalPolicyStep was modified by another user. Please refresh and try again',
  'Nexo:Workflow:ApprovalRequest:InvalidStateTransition': 'Cannot transition ApprovalRequest from {currentStatus} to {targetStatus}',
  'Nexo:Workflow:ApprovalRequest:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Workflow:ApprovalRequest:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Workflow:ApprovalRequest:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Workflow:ApprovalRequest:NotFound': 'ApprovalRequest not found',
  'Nexo:Workflow:ApprovalRequest:ConcurrencyConflict': 'ApprovalRequest was modified by another user. Please refresh and try again',
  'Nexo:Workflow:ApprovalRequest:DuplicateRequestNumber': 'A ApprovalRequest with the same request no. already exists.',
  'Nexo:Core:Area:NotFound': 'Area not found',
  'Nexo:Core:Area:ConcurrencyConflict': 'Area was modified by another user. Please refresh and try again',
  'Nexo:Core:Area:DistrictInAnotherActiveArea': 'LLD district {district} is already in the active area {area} of the same area type and product group.',
  'Nexo:Core:Area:ProductGroupNotAllowed': 'The area type {areaType} does not allow a product group on its areas.',
  'Nexo:Core:AreaDistrict:NotFound': 'AreaDistrict not found',
  'Nexo:Core:AreaDistrict:ConcurrencyConflict': 'AreaDistrict was modified by another user. Please refresh and try again',
  'Nexo:Core:AreaDistrict:AreaDistrictIsImmutable': 'The districts of an active or superseded area version cannot be changed; edit a draft.',
  'Nexo:Core:AreaType:NotFound': 'AreaType not found',
  'Nexo:Core:AreaType:ConcurrencyConflict': 'AreaType was modified by another user. Please refresh and try again',
  'Nexo:Core:AreaType:DuplicateCode': 'A AreaType with the same code already exists.',
  'Nexo:Core:AreaVersion:InvalidStateTransition': 'Cannot transition AreaVersion from {currentStatus} to {targetStatus}',
  'Nexo:Core:AreaVersion:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Core:AreaVersion:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Core:AreaVersion:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Core:AreaVersion:NotFound': 'AreaVersion not found',
  'Nexo:Core:AreaVersion:ConcurrencyConflict': 'AreaVersion was modified by another user. Please refresh and try again',
  'Nexo:Core:AreaVersion:AreaVersionIsImmutable': 'An active or superseded area version cannot be changed; edit a draft.',
  'Nexo:Core:AreaVersion:AreaVersionValidFromInvalid': 'Give the version a valid-from date of today or later, after the active version\'s, before activating it.',
  'Nexo:Core:AssignmentPolicy:NotFound': 'AssignmentPolicy not found',
  'Nexo:Core:AssignmentPolicy:ConcurrencyConflict': 'AssignmentPolicy was modified by another user. Please refresh and try again',
  'Nexo:Core:BatchJob:NotFound': 'BatchJob not found',
  'Nexo:Core:BatchJob:ConcurrencyConflict': 'BatchJob was modified by another user. Please refresh and try again',
  'Nexo:Core:BatchJobRun:NotFound': 'BatchJobRun not found',
  'Nexo:Core:BatchJobRun:ConcurrencyConflict': 'BatchJobRun was modified by another user. Please refresh and try again',
  'Nexo:Core:BusinessRule:InvalidStateTransition': 'Cannot transition BusinessRule from {currentStatus} to {targetStatus}',
  'Nexo:Core:BusinessRule:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Core:BusinessRule:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Core:BusinessRule:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Core:BusinessRule:NotFound': 'BusinessRule not found',
  'Nexo:Core:BusinessRule:ConcurrencyConflict': 'BusinessRule was modified by another user. Please refresh and try again',
  'Nexo:Core:BusinessRule:DuplicateRuleNumber': 'A BusinessRule with the same rule number already exists.',
  'Nexo:Core:CompanyProfile:NotFound': 'CompanyProfile not found',
  'Nexo:Core:CompanyProfile:ConcurrencyConflict': 'CompanyProfile was modified by another user. Please refresh and try again',
  'Nexo:Core:CompanyProfile:DuplicateOrgUnitId': 'A CompanyProfile with the same legal entity already exists.',
  'Nexo:Core:Country:NotFound': 'Country not found',
  'Nexo:Core:Country:ConcurrencyConflict': 'Country was modified by another user. Please refresh and try again',
  'Nexo:Core:Country:DuplicateCode': 'A Country with the same alpha-2 already exists.',
  'Nexo:Core:Country:DuplicateAlpha3Code': 'A Country with the same alpha-3 already exists.',
  'Nexo:Core:Currency:NotFound': 'Currency not found',
  'Nexo:Core:Currency:ConcurrencyConflict': 'Currency was modified by another user. Please refresh and try again',
  'Nexo:Core:Currency:DuplicateCode': 'A Currency with the same code already exists.',
  'Nexo:Core:DeliveryTerms:NotFound': 'DeliveryTerms not found',
  'Nexo:Core:DeliveryTerms:ConcurrencyConflict': 'DeliveryTerms was modified by another user. Please refresh and try again',
  'Nexo:Core:DeliveryTerms:DuplicateCode': 'A DeliveryTerms with the same code already exists.',
  'Nexo:Core:DocumentPageSetup:NotFound': 'DocumentPageSetup not found',
  'Nexo:Core:DocumentPageSetup:ConcurrencyConflict': 'DocumentPageSetup was modified by another user. Please refresh and try again',
  'Nexo:Core:DocumentTemplate:NotFound': 'DocumentTemplate not found',
  'Nexo:Core:DocumentTemplate:ConcurrencyConflict': 'DocumentTemplate was modified by another user. Please refresh and try again',
  'Nexo:Core:DocumentTemplate:NotSelectable': 'The selected template cannot be used for this document type.',
  'Nexo:Core:EntityTemplate:NotFound': 'EntityTemplate not found',
  'Nexo:Core:EntityTemplate:ConcurrencyConflict': 'EntityTemplate was modified by another user. Please refresh and try again',
  'Nexo:Core:EntityTemplate:VisibilityNotAllowed': 'This visibility level is not allowed for templates of this entity.',
  'Nexo:Core:EntityTemplate:DefaultNotAllowed': 'Templates for this entity cannot be set as default.',
  'Nexo:Core:EnumValue:NotFound': 'EnumValue not found',
  'Nexo:Core:EnumValue:ConcurrencyConflict': 'EnumValue was modified by another user. Please refresh and try again',
  'Nexo:Core:FieldRestrictionEntry:NotFound': 'FieldRestrictionEntry not found',
  'Nexo:Core:FieldRestrictionEntry:ConcurrencyConflict': 'FieldRestrictionEntry was modified by another user. Please refresh and try again',
  'Nexo:Core:FieldRestrictionSet:NotFound': 'FieldRestrictionSet not found',
  'Nexo:Core:FieldRestrictionSet:ConcurrencyConflict': 'FieldRestrictionSet was modified by another user. Please refresh and try again',
  'Nexo:Core:LldDistrict:NotFound': 'LldDistrict not found',
  'Nexo:Core:LldDistrict:ConcurrencyConflict': 'LldDistrict was modified by another user. Please refresh and try again',
  'Nexo:Core:LldDistrict:DuplicateCode': 'A LldDistrict with the same lld code already exists.',
  'Nexo:Core:NumberSeries:NotFound': 'NumberSeries not found',
  'Nexo:Core:NumberSeries:ConcurrencyConflict': 'NumberSeries was modified by another user. Please refresh and try again',
  'Nexo:Core:OrgRoleFunction:NotFound': 'OrgRoleFunction not found',
  'Nexo:Core:OrgRoleFunction:ConcurrencyConflict': 'OrgRoleFunction was modified by another user. Please refresh and try again',
  'Nexo:Core:OrgRoleFunction:DuplicateCode': 'A OrgRoleFunction with the same code already exists.',
  'Nexo:Core:OrgUnit:NotFound': 'OrgUnit not found',
  'Nexo:Core:OrgUnit:ConcurrencyConflict': 'OrgUnit was modified by another user. Please refresh and try again',
  'Nexo:Core:OrgUnit:CycleDetected': 'An org unit cannot be moved under itself or one of its own sub-units.',
  'Nexo:Core:OrgUnit:HasChildrenCannotDelete': 'The org unit \'{name}\' cannot be deleted while it has sub-units. Move or delete the sub-units first.',
  'Nexo:Core:OrgUnit:MemberInvalidValidityRange': 'Valid to must not be before Valid from — a membership with an inverted window can never grant access.',
  'Nexo:Core:OrgUnit:InUseCannotDelete': 'The org unit \'{name}\' cannot be deleted — data is still registered on it: {usages}. Remove or move that data first.',
  'Nexo:Core:OrgUnit:DuplicateCode': 'A OrgUnit with the same code already exists.',
  'Nexo:Core:OwnerDerivationRule:NotFound': 'OwnerDerivationRule not found',
  'Nexo:Core:OwnerDerivationRule:ConcurrencyConflict': 'OwnerDerivationRule was modified by another user. Please refresh and try again',
  'Nexo:Core:PaymentTerms:NotFound': 'PaymentTerms not found',
  'Nexo:Core:PaymentTerms:ConcurrencyConflict': 'PaymentTerms was modified by another user. Please refresh and try again',
  'Nexo:Core:PaymentTerms:DuplicateCode': 'A PaymentTerms with the same code already exists.',
  'Nexo:Core:ReceivingLocation:NotFound': 'ReceivingLocation not found',
  'Nexo:Core:ReceivingLocation:ConcurrencyConflict': 'ReceivingLocation was modified by another user. Please refresh and try again',
  'Nexo:Core:ReceivingLocation:DuplicateCode': 'A ReceivingLocation with the same code already exists.',
  'Nexo:Core:SetupPackage:NotFound': 'SetupPackage not found',
  'Nexo:Core:SetupPackage:ConcurrencyConflict': 'SetupPackage was modified by another user. Please refresh and try again',
  'Nexo:Core:SetupPackage:BuilderNotFound': 'No setup-package builder exists for this record type.',
  'Nexo:Core:SetupPackage:PackageIsEmpty': 'The package has no content to export or apply.',
  'Nexo:Core:SetupPackage:UnsupportedSchemaVersion': 'The package file uses a newer format than this system understands.',
  'Nexo:Core:SetupPackage:IntegrityCheckFailed': 'The package file content does not match its integrity fingerprint.',
  'Nexo:Core:SetupPackage:UnresolvableReference': 'The setup references a {entity} record ({id}) that has no transferable key — it may have been deleted. Repair or remove the reference, then build the package again.',
  'Nexo:Core:SetupPackage:SecretInPayload': 'The {entity} field {field} holds a secret, which a setup package never carries. The target environment supplies its own.',
  'Nexo:Core:TradeType:NotFound': 'TradeType not found',
  'Nexo:Core:TradeType:ConcurrencyConflict': 'TradeType was modified by another user. Please refresh and try again',
  'Nexo:Core:TradeType:DuplicateCode': 'A TradeType with the same code already exists.',
  'Nexo:Core:UnitOfMeasure:NotFound': 'UnitOfMeasure not found',
  'Nexo:Core:UnitOfMeasure:ConcurrencyConflict': 'UnitOfMeasure was modified by another user. Please refresh and try again',
  'Nexo:Core:UnitOfMeasure:DuplicateCode': 'A UnitOfMeasure with the same code already exists.',
  'Nexo:Core:UnitOfMeasureConversion:NotFound': 'UnitOfMeasureConversion not found',
  'Nexo:Core:UnitOfMeasureConversion:ConcurrencyConflict': 'UnitOfMeasureConversion was modified by another user. Please refresh and try again',
  'Nexo:Pricing:BasePrice:NotFound': 'BasePrice not found',
  'Nexo:Pricing:BasePrice:ConcurrencyConflict': 'BasePrice was modified by another user. Please refresh and try again',
  'Nexo:Pricing:InternalPriceLine:NotFound': 'InternalPriceLine not found',
  'Nexo:Pricing:InternalPriceLine:ConcurrencyConflict': 'InternalPriceLine was modified by another user. Please refresh and try again',
  'Nexo:Pricing:InternalPriceList:NotFound': 'InternalPriceList not found',
  'Nexo:Pricing:InternalPriceList:ConcurrencyConflict': 'InternalPriceList was modified by another user. Please refresh and try again',
  'Nexo:Pricing:InternalPriceList:InvalidValidityPeriod': 'Valid from must be on or before valid to.',
  'Nexo:Pricing:InternalPriceList:DuplicateLine': 'An identical price line already exists in this list (same organisation, supplier, trade type, product group, product and unit).',
  'Nexo:Pricing:InternalPriceList:OverlappingLine': '{lineCount} of this list\'s price lines are also in the active list {otherList} (valid from {otherValidFrom}), which overlaps this list from {overlapFrom}. A line can have only one price on a given day: end one list before the other starts, or remove the lines from one of them.',
  'Nexo:Pricing:InternalPriceList:DuplicateCode': 'A InternalPriceList with the same code already exists.',
  'Nexo:Pricing:PriceList:InvalidStateTransition': 'Cannot transition PriceList from {currentStatus} to {targetStatus}',
  'Nexo:Pricing:PriceList:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Pricing:PriceList:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Pricing:PriceList:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Pricing:PriceList:NotFound': 'PriceList not found',
  'Nexo:Pricing:PriceList:ConcurrencyConflict': 'PriceList was modified by another user. Please refresh and try again',
  'Nexo:Pricing:PriceList:DuplicateRow': 'A price list has at most one row per product or product group and unit. Merge or remove one of the rows.',
  'Nexo:Pricing:PriceList:ProductXorProductGroup': 'A base price row applies to exactly one of a product or a product group.',
  'Nexo:Pricing:PriceList:RowDoesNotFitListType': 'A calculation price row needs a component and a unit and has no product; a sales price row has no area, component or classes.',
  'Nexo:Pricing:PriceList:ClassSetsOnCalculationListsOnly': 'Only a calculation price list chooses class sets.',
  'Nexo:Pricing:PriceList:MoreThanOneAddOnDimension': 'A component\'s class sets name at most one add-on dimension for one product group and area.',
  'Nexo:Pricing:PriceList:ClassesNotInChosenSets': 'A price row\'s classes must come from the class sets the list chose for its component, area and product group.',
  'Nexo:Pricing:PriceList:DuplicatePriceListCode': 'A PriceList with the same code already exists.',
  'Nexo:Pricing:PriceListClassSet:NotFound': 'PriceListClassSet not found',
  'Nexo:Pricing:PriceListClassSet:ConcurrencyConflict': 'PriceListClassSet was modified by another user. Please refresh and try again',
  'Nexo:Sales:Customer:NotFound': 'Customer not found',
  'Nexo:Sales:Customer:ConcurrencyConflict': 'Customer was modified by another user. Please refresh and try again',
  'Nexo:Sales:Customer:DuplicateCustomerNumber': 'A Customer with the same customer no. already exists.',
  'Nexo:Sales:CustomerGroup:NotFound': 'CustomerGroup not found',
  'Nexo:Sales:CustomerGroup:ConcurrencyConflict': 'CustomerGroup was modified by another user. Please refresh and try again',
  'Nexo:Sales:CustomerGroup:DuplicateCode': 'A CustomerGroup with the same code already exists.',
  'Nexo:Sales:Invoice:InvalidStateTransition': 'Cannot transition Invoice from {currentStatus} to {targetStatus}',
  'Nexo:Sales:Invoice:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Sales:Invoice:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Sales:Invoice:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Sales:Invoice:NotFound': 'Invoice not found',
  'Nexo:Sales:Invoice:ConcurrencyConflict': 'Invoice was modified by another user. Please refresh and try again',
  'Nexo:Sales:Invoice:DuplicateInvoiceNumber': 'A Invoice with the same invoice no. already exists.',
  'Nexo:Sales:InvoiceLine:NotFound': 'InvoiceLine not found',
  'Nexo:Sales:InvoiceLine:ConcurrencyConflict': 'InvoiceLine was modified by another user. Please refresh and try again',
  'Nexo:Sales:Order:InvalidStateTransition': 'Cannot transition Order from {currentStatus} to {targetStatus}',
  'Nexo:Sales:Order:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Sales:Order:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Sales:Order:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Sales:Order:NotFound': 'Order not found',
  'Nexo:Sales:Order:ConcurrencyConflict': 'Order was modified by another user. Please refresh and try again',
  'Nexo:Sales:Order:CommercialTermsFrozenAfterConfirmation': '{fieldLabel} cannot be changed after the order has been confirmed.',
  'Nexo:Sales:Order:TotalFrozenAfterConfirmation': '{fieldLabel} cannot be changed after the order has been confirmed.',
  'Nexo:Sales:Order:DeliveryDateCannotMoveEarlier': 'The requested delivery date can only be moved later once the order is confirmed.',
  'Nexo:Sales:Order:LinesCannotBeRemovedAfterConfirmation': 'Order lines cannot be removed after the order has been confirmed.',
  'Nexo:Sales:Order:DuplicateOrderNumber': 'A Order with the same order number already exists.',
  'Nexo:Sales:OrderLine:NotFound': 'OrderLine not found',
  'Nexo:Sales:OrderLine:ConcurrencyConflict': 'OrderLine was modified by another user. Please refresh and try again',
  'Nexo:Integration:ImportProfile:NotFound': 'ImportProfile not found',
  'Nexo:Integration:ImportProfile:ConcurrencyConflict': 'ImportProfile was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationCallRecord:NotFound': 'IntegrationCallRecord not found',
  'Nexo:Integration:IntegrationCallRecord:ConcurrencyConflict': 'IntegrationCallRecord was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationCallRecord:NoActiveCallJob': 'No active external-call job is configured for adapter \'{adapterName}\'. Create one under Integration Jobs before requesting the call.',
  'Nexo:Integration:IntegrationCallRecord:CallAlreadyPending': 'A call for this record is already open (record {callRecordId}). Wait for its answer, or close it under External Calls.',
  'Nexo:Integration:IntegrationCallRecord:ReparseRequiresAnswer': 'There is no answer to reparse, or its outcome has already been applied.',
  'Nexo:Integration:IntegrationCallRecord:ReapplyRequiresUnappliedOutcome': 'There is no outcome to apply, or it has already been applied.',
  'Nexo:Integration:IntegrationCallRecord:MarkFailedRequiresOpenRecord': 'This call is closed: its outcome has already been applied.',
  'Nexo:Integration:IntegrationCallRecord:RetryRequiresTransportFailure': 'Only the latest call for this record can be retried, and only when it failed in transport and no other call for the record is open.',
  'Nexo:Integration:IntegrationClient:NotFound': 'IntegrationClient not found',
  'Nexo:Integration:IntegrationClient:ConcurrencyConflict': 'IntegrationClient was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationClient:DuplicateName': 'A IntegrationClient with the same name already exists.',
  'Nexo:Integration:IntegrationClientGrant:NotFound': 'IntegrationClientGrant not found',
  'Nexo:Integration:IntegrationClientGrant:ConcurrencyConflict': 'IntegrationClientGrant was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationConnection:NotFound': 'IntegrationConnection not found',
  'Nexo:Integration:IntegrationConnection:ConcurrencyConflict': 'IntegrationConnection was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationConnection:DuplicateName': 'A IntegrationConnection with the same name already exists.',
  'Nexo:Integration:IntegrationJob:NotFound': 'IntegrationJob not found',
  'Nexo:Integration:IntegrationJob:ConcurrencyConflict': 'IntegrationJob was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationJob:DuplicateName': 'A IntegrationJob with the same name already exists.',
  'Nexo:Integration:IntegrationJob:DuplicateInboundMessageType': 'A IntegrationJob with the same endpoint name already exists.',
  'Nexo:Integration:IntegrationOutboxRecord:NotFound': 'IntegrationOutboxRecord not found',
  'Nexo:Integration:IntegrationOutboxRecord:ConcurrencyConflict': 'IntegrationOutboxRecord was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationOutboxRecord:RetryBlockedByDeliveryInFlight': 'This record is being delivered right now. Wait for it to finish before retrying.',
  'Nexo:Integration:IntegrationOutboxRecord:DownloadRequiresProducedFile': 'This record is {status} and carries no file. Either delivery has not produced one yet, or the export was refused before anything was written.',
  'Nexo:Integration:IntegrationOutboxRecord:AcknowledgedVersionCannotBeResent': 'The recipient has answered this document version ({status}), so it is not sent again.',
  'Nexo:Integration:IntegrationOutboxRecord:AcknowledgementAlreadyApplied': 'This document version has already been answered: it is {status}, and a {answer} cannot change that.',
  'Nexo:Integration:IntegrationOutboxRecord:DocumentVersionChanged': 'This record already delivers another version of the document. A new version is delivered as a new record.',
  'Nexo:Integration:IntegrationRun:NotFound': 'IntegrationRun not found',
  'Nexo:Integration:IntegrationRun:ConcurrencyConflict': 'IntegrationRun was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationRun:OnlineImportRunning': 'Your import into {targetEntity} that started at {startedAt} is still running. Open it under Integration Runs, or wait for it to finish.',
  'Nexo:Integration:IntegrationStagingRecord:NotFound': 'IntegrationStagingRecord not found',
  'Nexo:Integration:IntegrationStagingRecord:ConcurrencyConflict': 'IntegrationStagingRecord was modified by another user. Please refresh and try again',
  'Nexo:Procurement:InboundMeasuringTicket:NotFound': 'InboundMeasuringTicket not found',
  'Nexo:Procurement:InboundMeasuringTicket:ConcurrencyConflict': 'InboundMeasuringTicket was modified by another user. Please refresh and try again',
  'Nexo:Procurement:InboundMeasuringTicket:AlreadyReceived': 'Measuring ticket {measuringTicketNumber} has already been received.',
  'Nexo:Procurement:InboundMeasuringTicketLine:NotFound': 'InboundMeasuringTicketLine not found',
  'Nexo:Procurement:InboundMeasuringTicketLine:ConcurrencyConflict': 'InboundMeasuringTicketLine was modified by another user. Please refresh and try again',
  'Nexo:Procurement:Supplier:NotFound': 'Supplier not found',
  'Nexo:Procurement:Supplier:ConcurrencyConflict': 'Supplier was modified by another user. Please refresh and try again',
  'Nexo:Procurement:Supplier:MultiplePrimaryBankAccounts': 'Only one bank account can be marked as primary.',
  'Nexo:Procurement:Supplier:DuplicateSupplierNumber': 'A Supplier with the same supplier no. already exists.',
  'Nexo:Procurement:SupplierAddress:NotFound': 'SupplierAddress not found',
  'Nexo:Procurement:SupplierAddress:ConcurrencyConflict': 'SupplierAddress was modified by another user. Please refresh and try again',
  'Nexo:Procurement:SupplierBankAccount:NotFound': 'SupplierBankAccount not found',
  'Nexo:Procurement:SupplierBankAccount:ConcurrencyConflict': 'SupplierBankAccount was modified by another user. Please refresh and try again',
  'Nexo:Procurement:SupplierContact:NotFound': 'SupplierContact not found',
  'Nexo:Procurement:SupplierContact:ConcurrencyConflict': 'SupplierContact was modified by another user. Please refresh and try again',
  'Nexo:Inventory:InventoryPeriodClose:NotFound': 'InventoryPeriodClose not found',
  'Nexo:Inventory:InventoryPeriodClose:ConcurrencyConflict': 'InventoryPeriodClose was modified by another user. Please refresh and try again',
  'Nexo:Inventory:InventoryPostingProfile:NotFound': 'InventoryPostingProfile not found',
  'Nexo:Inventory:InventoryPostingProfile:ConcurrencyConflict': 'InventoryPostingProfile was modified by another user. Please refresh and try again',
  'Nexo:Inventory:InventoryReservation:NotFound': 'InventoryReservation not found',
  'Nexo:Inventory:InventoryReservation:ConcurrencyConflict': 'InventoryReservation was modified by another user. Please refresh and try again',
  'Nexo:Inventory:InventoryTransaction:InvalidStateTransition': 'Cannot transition InventoryTransaction from {currentStatus} to {targetStatus}',
  'Nexo:Inventory:InventoryTransaction:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Inventory:InventoryTransaction:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Inventory:InventoryTransaction:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Inventory:InventoryTransaction:NotFound': 'InventoryTransaction not found',
  'Nexo:Inventory:InventoryTransaction:ConcurrencyConflict': 'InventoryTransaction was modified by another user. Please refresh and try again',
  'Nexo:Inventory:InventoryTransaction:ReceiptQuantityNotPositive': 'Receipt quantity must be greater than zero.',
  'Nexo:Inventory:Product:NotFound': 'Product not found',
  'Nexo:Inventory:Product:ConcurrencyConflict': 'Product was modified by another user. Please refresh and try again',
  'Nexo:Inventory:Product:DuplicateProductNumber': 'A Product with the same product no. already exists.',
  'Nexo:Inventory:ProductGroup:NotFound': 'ProductGroup not found',
  'Nexo:Inventory:ProductGroup:ConcurrencyConflict': 'ProductGroup was modified by another user. Please refresh and try again',
  'Nexo:Inventory:ProductGroup:DuplicateCode': 'A ProductGroup with the same code already exists.',
  'Nexo:Inventory:StandardCostPrice:NotFound': 'StandardCostPrice not found',
  'Nexo:Inventory:StandardCostPrice:ConcurrencyConflict': 'StandardCostPrice was modified by another user. Please refresh and try again',
  'Nexo:Inventory:StandardCostVersion:InvalidStateTransition': 'Cannot transition StandardCostVersion from {currentStatus} to {targetStatus}',
  'Nexo:Inventory:StandardCostVersion:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Inventory:StandardCostVersion:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Inventory:StandardCostVersion:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Inventory:StandardCostVersion:NotFound': 'StandardCostVersion not found',
  'Nexo:Inventory:StandardCostVersion:ConcurrencyConflict': 'StandardCostVersion was modified by another user. Please refresh and try again',
  'Nexo:TaskManagement:WorkTask:InvalidStateTransition': 'Cannot transition WorkTask from {currentStatus} to {targetStatus}',
  'Nexo:TaskManagement:WorkTask:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:TaskManagement:WorkTask:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:TaskManagement:WorkTask:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:TaskManagement:WorkTask:NotFound': 'WorkTask not found',
  'Nexo:TaskManagement:WorkTask:ConcurrencyConflict': 'WorkTask was modified by another user. Please refresh and try again',
};
